// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAccountOrderMatrixCoverageDto } from './IAccountOrderMatrixCoverageDto';
import {
    IAccountOrderMatrixCoverageDtoFromJSON,
    IAccountOrderMatrixCoverageDtoFromJSONTyped,
    IAccountOrderMatrixCoverageDtoToJSON,
    IAccountOrderMatrixCoverageDtoToJSONTyped,
} from './IAccountOrderMatrixCoverageDto';
import type { ILimitedUsePeriodDto } from './ILimitedUsePeriodDto';
import {
    ILimitedUsePeriodDtoFromJSON,
    ILimitedUsePeriodDtoFromJSONTyped,
    ILimitedUsePeriodDtoToJSON,
    ILimitedUsePeriodDtoToJSONTyped,
} from './ILimitedUsePeriodDto';
import type { IAccountOrderDto } from './IAccountOrderDto';
import {
    IAccountOrderDtoFromJSON,
    IAccountOrderDtoFromJSONTyped,
    IAccountOrderDtoToJSON,
    IAccountOrderDtoToJSONTyped,
} from './IAccountOrderDto';

/**
 * 
 * @export
 * @interface IAccountOrderMatrixDto
 */
export interface IAccountOrderMatrixDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderMatrixDto
     */
    payout_definition_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderMatrixDto
     */
    limited_payout_definition_id?: number;
    /**
     * 
     * @type {Array<ILimitedUsePeriodDto>}
     * @memberof IAccountOrderMatrixDto
     */
    limited_use_periods?: Array<ILimitedUsePeriodDto>;
    /**
     * 
     * @type {number}
     * @memberof IAccountOrderMatrixDto
     */
    priority?: number;
    /**
     * 
     * @type {Array<IAccountOrderMatrixCoverageDto>}
     * @memberof IAccountOrderMatrixDto
     */
    matrix_coverages?: Array<IAccountOrderMatrixCoverageDto>;
    /**
     * 
     * @type {Array<Array<IAccountOrderDto>>}
     * @memberof IAccountOrderMatrixDto
     */
    account_orders?: Array<Array<IAccountOrderDto>>;
    /**
     * 
     * @type {Array<Array<IAccountOrderDto>>}
     * @memberof IAccountOrderMatrixDto
     */
    limited_account_orders?: Array<Array<IAccountOrderDto>>;
}

/**
 * Check if a given object implements the IAccountOrderMatrixDto interface.
 */
export function instanceOfIAccountOrderMatrixDto(value: object): value is IAccountOrderMatrixDto {
    return true;
}

export function IAccountOrderMatrixDtoFromJSON(json: any): IAccountOrderMatrixDto {
    return IAccountOrderMatrixDtoFromJSONTyped(json, false);
}

export function IAccountOrderMatrixDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountOrderMatrixDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payout_definition_id': json['payout_definition_id'] == null ? undefined : json['payout_definition_id'],
        'limited_payout_definition_id': json['limited_payout_definition_id'] == null ? undefined : json['limited_payout_definition_id'],
        'limited_use_periods': json['limited_use_periods'] == null ? undefined : ((json['limited_use_periods'] as Array<any>).map(ILimitedUsePeriodDtoFromJSON)),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'matrix_coverages': json['matrix_coverages'] == null ? undefined : ((json['matrix_coverages'] as Array<any>).map(IAccountOrderMatrixCoverageDtoFromJSON)),
        'account_orders': json['account_orders'] == null ? undefined : json['account_orders'],
        'limited_account_orders': json['limited_account_orders'] == null ? undefined : json['limited_account_orders'],
    };
}

export function IAccountOrderMatrixDtoToJSON(json: any): IAccountOrderMatrixDto {
    return IAccountOrderMatrixDtoToJSONTyped(json, false);
}

export function IAccountOrderMatrixDtoToJSONTyped(value?: IAccountOrderMatrixDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payout_definition_id': value['payout_definition_id'],
        'limited_payout_definition_id': value['limited_payout_definition_id'],
        'limited_use_periods': value['limited_use_periods'] == null ? undefined : ((value['limited_use_periods'] as Array<any>).map(ILimitedUsePeriodDtoToJSON)),
        'priority': value['priority'],
        'matrix_coverages': value['matrix_coverages'] == null ? undefined : ((value['matrix_coverages'] as Array<any>).map(IAccountOrderMatrixCoverageDtoToJSON)),
        'account_orders': value['account_orders'],
        'limited_account_orders': value['limited_account_orders'],
    };
}

